import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";

import  { Card } from "rhombus-react";

import { CAROUSEL_AD_TYPES, SOCIAL_AD_TYPES } from "utils/constants";
import { MAX_CAROUSEL_CARDS_BY_ADTYPE, UNEDITABLE_CARD_MESSAGE } from "social/constants/common";

import ToggleField from "widgets/ToggleField";

import { nonDynamicFields } from "social/utils";
import FacebookCarouselCardForm from "./FacebookCarouselCardForm";
import CardHeader from "./CardHeader";
import CardSelector from "./CardSelector";

import "./CardContent.css";

let dynamicNormalizers = nonDynamicFields();

export default function FacebookCardContent(props){
	const {
		libraryId,
		adType,
		isViewOnly,
		isEditMode,
		showPristineErrors,
		navigationActions,
		doVersionsExist,
	} = props;

	const maxCards = MAX_CAROUSEL_CARDS_BY_ADTYPE[adType];

	let extra = {};
	let extraCardHeaderProps = {};

	if(adType === SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO){
		extra = { ...dynamicNormalizers };
	}

	if (doVersionsExist) {
		extraCardHeaderProps.deleteCardTooltip = UNEDITABLE_CARD_MESSAGE;
		extraCardHeaderProps.duplicateCardTooltip = UNEDITABLE_CARD_MESSAGE;
	}

	return (
		<Card
			className="carousel-card-content"
			header = {(
				<>
					<span className="c-heading-descriptive">
						{`Card Content - Carousel must contain between 2-${maxCards} cards`}
					</span>
					<Field
						name = "optimizeCardOrder"
						className = "optimization-toggle"
						component = {ToggleField}
						label = "Optimize Card Order"
						disabled = {isViewOnly}
						{...extra}
					/>
				</>
			)}
			isCollapsable
			isVisible
		>
			<CardSelector
				adType={adType}
				libraryId={libraryId}
				isViewOnly={isViewOnly || doVersionsExist}
				showPristineErrors={showPristineErrors}
			/>
			<div className="form-container">
				<CardHeader
					adType={adType}
					isViewOnly={isViewOnly || doVersionsExist}
					{...extraCardHeaderProps}
				/>
				<FacebookCarouselCardForm
					libraryId = {libraryId}
					isViewOnly = {isViewOnly}
					isEditMode = {isEditMode}
					showPristineErrors = {showPristineErrors}
					navigationActions = {navigationActions}
					adType = {adType}
					doVersionsExist = {doVersionsExist}
				/>
			</div>
		</Card>
	);
}

FacebookCardContent.displayName = "FacebookCardContent";
FacebookCardContent.propTypes = {
	libraryId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	adType: PropTypes.oneOf(CAROUSEL_AD_TYPES),
	showPristineErrors: PropTypes.bool,
	navigationActions: PropTypes.object,
};
